import { ISagaCb } from '@typings/requestPayloads'
import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IEditCustomFieldPayload extends ISagaCb {
    data: {
        name: string
        label: string
        profileItemType: 'Custom' | 'Main'
        customType: string
        customTypePossibleValues: { identifer: string; value: string }[]
        priority: number
        iTPStatus: 'Enable' | 'Disable'
        registrationStatus: 'Enable' | 'Disable'
        profileStatus: 'Enable' | 'Disable'
        filterStatus: 'Enable' | 'Disable'
        sharedListStatus: 'Enable' | 'Disable'
        userVisibilityStatus: 'Enable' | 'Disable'
    }
    id: string
}

export interface IEditCustomFieldState {
    status: string
    data: any
    errors: any
}

const initialState: IEditCustomFieldState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const editCustomField = createSlice({
    name: 'event-profiles/edit-custom-field',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IEditCustomFieldPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editCustomFieldActions = editCustomField.actions
export default editCustomField.reducer
